import moment from 'moment';
import {
  ALL_SITES,
  GET_VENDOR_USERS,
  VENDOR_ASSIGN,
  ASSIGN_FREQUENCY, UPDATE_PRIMARY_QUERY, UPDATE_SEARCH_QUERY, GET_FILTERS,
  GET_SITE_REPORTS,
  UPDATE_SITE_REPORTS,
  UPDATE_SITE,
  REMOVE_MAPPING,
  REMOVE_FREQUENCY,
  ASSIGN_FLEX_RECEIVE_DATE,
  DELETED_SITES,
  UPDATE_ALL_SITE_DATA,
} from '../actionTypes';

const initalState = {
  allSites: [],
  totalSitePages: 0,
  currentPage: 0,
  vendorUsers: [],
  primaryQuery: '',
  searchQuery: '',
  cities: [],
  states: [],
  mediaTypes: [],
};

const SitesReducer = (state = initalState, action) => {
  switch (action.type) {
    case ALL_SITES: {
      return {
        ...state,
        allSites: action.payload.data,
        totalSitePages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
        currentPageCount: action.payload.currentPageCount,
      };
    }
    case GET_VENDOR_USERS: {
      return {
        ...state,
        vendorUsers: [...action.payload.users],
      };
    }
    case VENDOR_ASSIGN: {
      const { data } = action
      const { vendorUsers } = state
      const newSites = [...state.allSites]
      const user = vendorUsers.find((item) => item.value === data.vendorUserId)
      data.siteId.map((item) => {
        const ind = newSites.findIndex((itm) => itm.id === item)
        newSites[ind].monitor = user.text
        return true;
      })
      return {
        ...state,
        allSites: [...newSites],
      }
    }
    case ASSIGN_FREQUENCY: {
      const { data } = action
      const newSites = [...state.allSites]
      data.siteId.map((item) => {
        const ind = newSites.findIndex((itm) => itm.id === item)
        newSites[ind].frequency = data.frequency
        return true;
      })
      return {
        ...state,
        allSites: [...newSites],
      }
    }
    case UPDATE_PRIMARY_QUERY: {
      return {
        ...state,
        primaryQuery: action.payload,
      }
    }
    case UPDATE_SEARCH_QUERY: {
      return {
        ...state,
        searchQuery: action.payload,
      }
    }
    case GET_FILTERS: {
      const { cities, states, mediaTypes } = action.payload
      return {
        ...state,
        cities,
        states,
        mediaTypes,
      }
    }
    case GET_SITE_REPORTS: {
      const sites = [...state.allSites]
      const ind = sites.findIndex((item) => item.id === action.siteId)
      sites[ind].site_reports = [...action.payload.data]
      return {
        ...state,
        allSites: [...sites],
      }
    }
    case UPDATE_SITE_REPORTS: {
      const sites = [...state.allSites]
      const ind = sites.findIndex((item) => item.id === action.siteId)
      const reports = [...sites[ind].site_reports]
      const ind1 = reports.findIndex((item) => item.id === action.siteReportId)
      reports[ind1] = { ...action.payload }
      sites[ind].site_reports = [...reports]
      return {
        ...state,
        allSites: [...sites],
      }
    }
    case UPDATE_SITE: {
      const { siteId, newStartDate, newEndDate } = action.payload
      const sites = [...state.allSites]
      siteId.map((site) => {
        const ind = sites.findIndex((item) => item.id === site)
        if (newStartDate) {
          sites[ind].newStartDate = moment(newStartDate).format('YYYY-MM-DD');
        }
        if (newEndDate) {
          sites[ind].newEndDate = moment(newEndDate).format('YYYY-MM-DD');
        }
        return true;
      })

      return {
        ...state,
        allSites: [...sites],
      }
    }
    case REMOVE_MAPPING: {
      const id = action.payload
      const sites = [...state.allSites]
      const ind = sites.findIndex((item) => item.id === id)
      sites[ind].monitor = null
      return {
        ...state,
        allSites: [...sites],
      }
    }
    case REMOVE_FREQUENCY: {
      const id = action.payload
      const sites = [...state.allSites]
      const ind = sites.findIndex((item) => item.id === id)
      sites[ind].frequency = null
      return {
        ...state,
        allSites: [...sites],
      }
    }
    case ASSIGN_FLEX_RECEIVE_DATE: {
      const data = action.payload
      const newSites = [...state.allSites]
      data.siteId.map((item) => {
        const ind = newSites.findIndex((itm) => itm.id === item)
        newSites[ind].flexReceivedDate = moment(data.newDate).format('DD MMM YYYY')
        return true;
      })
      return {
        ...state,
        allSites: [...newSites],
      }
    }
    case DELETED_SITES: {
      const id = action.payload;
      const oldSites = [...state.allSites]
      const index = oldSites.findIndex((itm) => itm.id === id)
      const newSites = [...oldSites.slice(0, index), ...oldSites.slice(index + 1)]
      return {
        ...state,
        allSites: [...newSites],
      }
    }
    case UPDATE_ALL_SITE_DATA: {
      const { siteId, data } = action.payload;
      const oldSites = [...state.allSites]
      const index = oldSites.findIndex((itm) => itm.id === siteId)
      const site = oldSites.find((itm) => itm.id === siteId)
      const newSite = { ...site, ...data }
      const newSites = [...oldSites.slice(0, index), { ...newSite }, ...oldSites.slice(index + 1)]
      return {
        ...state,
        allSites: [...newSites],
      }
    }
    default:
      return state;
  }
};

export default SitesReducer;
